import React from 'react';
import Container from '@mui/material/Container';
import { Typography, Box, Button } from '@mui/material';
import { PageNotFoundIllustration } from '../../../assets/illustrations';
import { RouterLink } from '../../../routes/components';

export default function NotFound() {
  return (
    <Box
      sx={{
        width: 1,
        mx: 'auto',
        my: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: '1 1 auto',
        textAlign: 'center',
        flexDirection: 'column',
        p: (theme) => theme.spacing(3, 2, 10, 2),
      }}
    >
      <Container>
        <Typography variant="h3" sx={{ mb: 2 }}>
          Sorry, page not found!
        </Typography>

        <Typography sx={{ color: 'text.secondary' }}>
          Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your
          spelling.
        </Typography>

        <PageNotFoundIllustration sx={{ my: { xs: 5, sm: 10 } }} />

        <div>
          <Button component={RouterLink} href="/home" size="large" variant="contained">
            Go to home
          </Button>
        </div>
      </Container>
    </Box>
  );
}
